import { courses } from '@/mocks/courses';

export default function CourseCards() {
  return (
    <section id="konzepte" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 text-accent-900 px-4 py-1.5 text-xs md:text-sm font-semibold">
            <i className="ri-book-open-line"></i>
            Meine drei Kurskonzepte
          </span>
          <div className="mt-4">
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
              Fertig ausgearbeitet. Direkt einsetzbar.
            </h2>
          </div>
          <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
            Drei praxiserprobte Kurskonzepte, die Fachkräfte eigenständig in ihrer
            Einrichtung einsetzen können – einmalig erwerben, dauerhaft nutzen, keine
            laufenden Lizenzgebühren.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {courses.map((course) => (
            <article
              key={course.id}
              className="group flex flex-col rounded-lg bg-background-50 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={course.image}
                  alt={course.title}
                  title={`${course.title} Kurskonzept`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 rounded-full bg-background-50/95 text-foreground-800 text-xs font-semibold px-3 py-1.5">
                  {course.badge}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-6 md:p-7">
                <div className="flex items-center gap-2 text-primary-600">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={course.icon}></i>
                  </span>
                  <span className="text-xs font-semibold uppercase tracking-wide">
                    {course.modules} Module
                  </span>
                </div>

                <h3 className="mt-4 text-xl md:text-2xl font-heading font-semibold text-foreground-950 leading-snug min-h-[2.75em]">
                  {course.title}
                </h3>
                <p className="mt-2 text-sm font-medium text-primary-700 min-h-[2.86em]">
                  {course.subtitle}
                </p>

                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                  {course.description}
                </p>

                <ul className="mt-5 space-y-2.5 flex-1">
                  {course.highlights.map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-sm text-foreground-700">
                      <span className="mt-0.5 w-4 h-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-900 shrink-0">
                        <i className="ri-check-line text-xs"></i>
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>

                <div className="mt-6 pt-6 border-t border-background-200 flex items-end justify-between">
                  <div>
                    <p className="text-xs text-foreground-500">Einmaliger Erwerb</p>
                    <p className="text-2xl font-heading font-semibold text-foreground-950">
                      {course.price}
                    </p>
                    <p className="text-xs text-foreground-500">keine Lizenzgebühren</p>
                  </div>
                  <a
                    href="#kontakt"
                    className="whitespace-nowrap rounded-full bg-primary-500 text-background-50 px-5 py-2.5 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    Anfragen
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}